<script>
export default {
  name: "InfoComponent",
  props: {
    imageSrc: {
      type: String,
      required: true
    },
    pageAlias: {
      type: String,
      required: true
    },
    pageName: {
      type: String,
      required: true
    },
    documentPrompt: {
      type: String,
      required: true
    },
  }
}
</script>

<template>
  <div class="td info-col">
    <div>
      <img class="image" :src="imageSrc" />
      <div class="info">
        <div class="name">
          <router-link :to="'/oc/' + pageAlias">
            {{ pageName }}
          </router-link>
        </div>
        <span class="prompt">
          <span>Потребуются документы:</span>
          <span v-html="documentPrompt"></span>
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped>

.image {
  max-width: 154px;
  vertical-align: middle;
  margin-right: 10px;
}

.info {
  vertical-align: middle;
  display: inline-block;
}

.name a {
  border-bottom: 1px dashed #000000;
  text-decoration: none;
  display: inline-block;
  margin-right: 5px;
  color: #000;
  margin-bottom: 10px;
}

.name a:hover {
  border-bottom: 1px dashed transparent;
}

.name svg {
  color: #b1b1b1;
}

.prompt {
  color: #6c6c6c;
}

.td>div {
  display: flex;
  align-items: center;
}

</style>
